import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarFudokan2 extends Component {
  state = {
    registered: {},
  };

  seminar = "fudokan"; // ✅ unique key for this dojo

  componentDidMount() {
    this.fetchRegistered();
    // Optional: auto-refresh every 10 seconds for live sync
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch registered participants
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Failed to fetch Fudokan data:", err);
    }
  };

  // ✅ Handle register / unregister
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // Unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });
      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // Register confirmation
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Display participants
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 default, 🔴 registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Fudokan Dojo Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Mr.Wissarut Maharakkhaka")}
        <br />
        {this.renderParticipant(2, "นางสาวอรทัย ลอยเมฆ")}
        <br />
        {this.renderParticipant(3, "Mr.CHOOCHAI CHINNAWONG")}
        <br />
        {this.renderParticipant(4, "นายเกล้า รัศมิทัต")}
        <br />
        {this.renderParticipant(5, "นางสาวบุศยรินทร์ รื่นรวยทรัพย์")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarFudokan2;
